import coffeeIcon from "assets/icons/schoolPage/coffe-icon.png";
import handWithCashIcon from "assets/icons/schoolPage/hand-with-cash-icon.png";
import personIcon from "assets/icons/schoolPage/person-icon.png";
import socksIcon from "assets/icons/schoolPage/socks-icon.png";
import watchIcon from "assets/icons/schoolPage/watch-icon.png";
import squareIcon from "assets/icons/schoolPage/square-icon.png";

import i18n from "i18n";

const features = {
  price: (city) => ({
    img: handWithCashIcon,
    title: `${i18n.t("schoolPage.priceFeatureTitle")}`,
    content: `${i18n.t(`schoolPage.priceFeatureBody.${city}`)}`,
  }),
  hours: (city) => ({
    img: watchIcon,
    title: `${i18n.t("schoolPage.hoursFeatureTitle")}`,
    content: `${i18n.t(`schoolPage.hoursFeatureBody.${city}`)}`,
  }),
  trainer: () => ({
    img: personIcon,
    title: `${i18n.t("schoolPage.trainerFeatureTitle")}`,
    content: `${i18n.t(`schoolPage.trainerFeatureBody`)}`,
  }),
  socks: () => ({
    img: socksIcon,
    title: `${i18n.t("schoolPage.socksFeatureTitle")}`,
    content: `${i18n.t(`schoolPage.socksFeatureBody`)}`,
  }),
  coffee: () => ({
    img: coffeeIcon,
    title: `${i18n.t("schoolPage.coffeeFeatureTitle")}`,
    content: `${i18n.t(`schoolPage.coffeeFeatureBody`)}`,
  }),
  rooms: (city) => ({
    img: squareIcon,
    title: `${i18n.t("schoolPage.roomsFeatureTitle")}`,
    content: `${i18n.t(`schoolPage.roomsFeatureBody.${city}`)}`,
  }),
};

const getFeatures = (city, featuresList = []) => {
  return featuresList.map((featureName) => {
    return features[featureName](city);
  });
};

export const getSchoolsConfig = () => {
  return {
    wroclaw: {
      doesCityHavePackages: true,
      schoolOfferImages: [
        {
          title: "First school image",
          src: "/images/wroclaw/about-us/about-picture-4.v2.jpg",
          alt: "First school image",
        },
        {
          title: "Second school image",
          src: "/images/schoolPage/school-1.jpg",
          alt: "Second school image",
        },
        {
          title: "Third school image",
          src: "/images/schoolPage/school-2.jpg",
          alt: "Third school image",
        },
        {
          title: "Fourth school image",
          src: "/images/schoolPage/school-3.jpg",
          alt: "Fourth school image",
        },
        {
          title: "Fifth school image",
          src: "/images/schoolPage/school-4.jpg",
          alt: "Fifth school image",
        },
        {
          title: "Sixth school image",
          src: "/images/schoolPage/school-5.jpg",
          alt: "Sixth school image",
        },
      ],
      schoolOfferCatalog: "/documents/wroclaw/school-catalog.pdf",
      reviews: [
        {
          img: "/images/schoolPage/review-1.jpg",
          name: "SP99",
          href: "https://sp-99.edu.wroclaw.pl/index.php/2023/10/03/wycieczka-klas-6bc-do-rynku-i-pixel-xl/",
        },
        {
          img: "/images/schoolPage/review-2.jpg",
          name: "SP118",
          href: "https://sp118.pl/klasa-3e-swietuje-dzien-dziecka-w-pixel-xl/",
        },
        {
          img: "/images/schoolPage/review-3.jpg",
          name: "SP7<br>LUBIN",
          href: "https://sp7lubin.pl/klasa-4a-odwiedzila-kolejkowo-wroclaw-oraz-pixel-xl/",
        },
      ],
      features: getFeatures("wroclaw", [
        "price",
        "hours",
        "trainer",
        "socks",
        "coffee",
        "rooms",
      ]),
      updateDate: "17/03/2025",
      minimalPersonCount: 16,
    },
    katowice: {
      doesCityHavePackages: true,
      schoolOfferImages: [
        {
          title: "First school image",
          src: "/images/schoolPage/katowice-about-1.jpg",
          alt: "First school image",
        },
        {
          title: "Second school image",
          src: "/images/schoolPage/school-1.jpg",
          alt: "Second school image",
        },
        {
          title: "Third school image",
          src: "/images/schoolPage/school-2.jpg",
          alt: "Third school image",
        },
        {
          title: "Fourth school image",
          src: "/images/schoolPage/school-3.jpg",
          alt: "Fourth school image",
        },
        {
          title: "Fifth school image",
          src: "/images/schoolPage/school-4.jpg",
          alt: "Fifth school image",
        },
        {
          title: "Sixth school image",
          src: "/images/schoolPage/school-5.jpg",
          alt: "Sixth school image",
        },
      ],
      schoolOfferCatalog: "/documents/katowice/school-catalog.pdf",
      reviews: [
        {
          img: "/images/schoolPage/review-1.jpg",
          name: "SP7",
          href: "https://kornelmakuszynskisp7.pl/wyjazd-do-centrum-rozrywki-i-gier-pixel-xl-w-katowicach,190,pl",
        },
        {
          img: "/images/schoolPage/review-2.jpg",
          name: "SP58",
          href: "https://sp58katowice.pl/index.php/3909-w-pixel-xl",
        },
        {
          img: "/images/schoolPage/review-3.jpg",
          name: "SP10",
          href: "https://sp10kat.szkolnastrona.pl/a,1237,polkolonie-w-naszej-szkole-pelne-wrazen-i-niezapomnianych-chwil",
        },
      ],
      features: getFeatures("katowice", [
        "price",
        "hours",
        "trainer",
        "socks",
        "coffee",
        "rooms",
      ]),
      updateDate: "17/03/2025",
      minimalPersonCount: 8,
    },
    "warszawa-box": {
      doesCityHavePackages: false,
      schoolOfferImages: [
        {
          title: "First school image",
          src: "/images/warszawa-box/about-us/about-picture-6.v2.jpg",
          alt: "First school image",
        },
        {
          title: "Second school image",
          src: "/images/warszawa-box/about-us/about-picture-1.v2.jpg",
          alt: "Second school image",
        },
        {
          title: "Third school image",
          src: "/images/warszawa-box/about-us/about-picture-2.v2.jpg",
          alt: "Third school image",
        },
        {
          title: "Fourth school image",
          src: "/images/warszawa-box/about-us/about-picture-3.v2.jpg",
          alt: "Fourth school image",
        },
        {
          title: "Fifth school image",
          src: "/images/warszawa-box/about-us/about-picture-4.v2.jpg",
          alt: "Fifth school image",
        },
        {
          title: "Sixth school image",
          src: "/images/warszawa-box/about-us/about-picture-5.v2.jpg",
          alt: "Sixth school image",
        },
      ],
      schoolOfferCatalog: "/documents/warszawa-box/school-catalog.pdf",
      features: getFeatures("warszawa-box", [
        "price",
        "hours",
        "trainer",
        "socks",
        "rooms",
      ]),
      updateDate: "7/04/2025",
      minimalPersonCount: 16,
    },
    gdansk: {
      doesCityHavePackages: true,
      schoolOfferImages: [
        {
          title: "First school image",
          src: "/images/gdansk/about-us/about-picture-v2.png",
          alt: "First school image",
        },
        {
          title: "Second school image",
          src: "/images/schoolPage/school-1.jpg",
          alt: "Second school image",
        },
        {
          title: "Third school image",
          src: "/images/schoolPage/school-2.jpg",
          alt: "Third school image",
        },
        {
          title: "Fourth school image",
          src: "/images/schoolPage/school-3.jpg",
          alt: "Fourth school image",
        },
        {
          title: "Fifth school image",
          src: "/images/schoolPage/school-4.jpg",
          alt: "Fifth school image",
        },
        {
          title: "Sixth school image",
          src: "/images/schoolPage/school-5.jpg",
          alt: "Sixth school image",
        },
      ],
      schoolOfferCatalog: "/documents/gdansk/school-catalog.pdf",
      reviews: [
        {
          img: "/images/schoolPage/review-1.jpg",
          name: "SP2",
          href: "https://sp2reda.pl/wycieczka-klasy-4b-do-pixel-xl-w-gdansku-z-okazji-mikolajek",
        },
        {
          img: "/images/schoolPage/review-2.jpg",
          name: "SP3",
          href: "https://sp3.edu.gdansk.pl/pl/art/5a-w-pixel-xl.86336.html",
        },
        {
          img: "/images/schoolPage/review-3.jpg",
          name: "ZSO10",
          href: "https://zso10.edu.gdansk.pl/pl/art/wspolpraca-sie-oplaca.86724.html",
        },
      ],
      features: getFeatures("gdansk", [
        "price",
        "hours",
        "trainer",
        "socks",
        "coffee",
        "rooms",
      ]),
      updateDate: "17/03/2025",
      minimalPersonCount: 16,
    },
    poznan: {
      doesCityHavePackages: true,
      schoolOfferImages: [
        {
          title: "First school image",
          src: "/images/poznan/about-us/about-picture-1.jpg",
          alt: "First school image",
        },
        {
          title: "Second school image",
          src: "/images/poznan/about-us/about-picture-2.jpg",
          alt: "Second school image",
        },
        {
          title: "Third school image",
          src: "/images/poznan/about-us/about-picture-3.jpg",
          alt: "Third school image",
        },
        {
          title: "Fourth school image",
          src: "/images/poznan/about-us/about-picture-4.jpg",
          alt: "Fourth school image",
        },
        {
          title: "Fifth school image",
          src: "/images/poznan/about-us/about-picture-5.jpg",
          alt: "Fifth school image",
        },
        {
          title: "Sixth school image",
          src: "/images/poznan/about-us/about-picture-6.jpg",
          alt: "Sixth school image",
        },
      ],
      schoolOfferCatalog: "/documents/gdansk/school-catalog.pdf",
      features: getFeatures("poznan", [
        "price",
        "hours",
        "trainer",
        "socks",
        "coffee",
        "rooms",
      ]),
      updateDate: "17/03/2025",
      minimalPersonCount: 16,
    },
  };
};
